import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations - Last updated: 2025-12-29
import ptBRCommon from '../locales/pt-BR/common.json';
import ptBRAuth from '../locales/pt-BR/auth.json';
import ptBRDashboard from '../locales/pt-BR/dashboard.json';
import ptBRTickets from '../locales/pt-BR/tickets.json';
import ptBRContacts from '../locales/pt-BR/contacts.json';
import ptBRConnections from '../locales/pt-BR/connections.json';
import ptBRQueues from '../locales/pt-BR/queues.json';
import ptBRUsers from '../locales/pt-BR/users.json';
import ptBRQuickReplies from '../locales/pt-BR/quickReplies.json';
import ptBRTags from '../locales/pt-BR/tags.json';
import ptBRSettings from '../locales/pt-BR/settings.json';
import ptBRAiAgents from '../locales/pt-BR/aiAgents.json';
import ptBRFlowBuilder from '../locales/pt-BR/flowBuilder.json';
import ptBRCrm from '../locales/pt-BR/crm.json';
import ptBRKnowledge from '../locales/pt-BR/knowledge.json';
import ptBRIntegrations from '../locales/pt-BR/integrations.json';
import ptBRScheduled from '../locales/pt-BR/scheduled.json';
import ptBRAdmin from '../locales/pt-BR/admin.json';
import ptBRChat from '../locales/pt-BR/chat.json';
import ptBRMediaLibrary from '../locales/pt-BR/mediaLibrary.json';

import enCommon from '../locales/en/common.json';
import enAuth from '../locales/en/auth.json';
import enDashboard from '../locales/en/dashboard.json';
import enTickets from '../locales/en/tickets.json';
import enContacts from '../locales/en/contacts.json';
import enConnections from '../locales/en/connections.json';
import enQueues from '../locales/en/queues.json';
import enUsers from '../locales/en/users.json';
import enQuickReplies from '../locales/en/quickReplies.json';
import enTags from '../locales/en/tags.json';
import enSettings from '../locales/en/settings.json';
import enAiAgents from '../locales/en/aiAgents.json';
import enFlowBuilder from '../locales/en/flowBuilder.json';
import enCrm from '../locales/en/crm.json';
import enKnowledge from '../locales/en/knowledge.json';
import enIntegrations from '../locales/en/integrations.json';
import enScheduled from '../locales/en/scheduled.json';
import enAdmin from '../locales/en/admin.json';
import enMediaLibrary from '../locales/en/mediaLibrary.json';

import esCommon from '../locales/es/common.json';
import esAuth from '../locales/es/auth.json';
import esDashboard from '../locales/es/dashboard.json';
import esTickets from '../locales/es/tickets.json';
import esContacts from '../locales/es/contacts.json';
import esConnections from '../locales/es/connections.json';
import esQueues from '../locales/es/queues.json';
import esUsers from '../locales/es/users.json';
import esQuickReplies from '../locales/es/quickReplies.json';
import esTags from '../locales/es/tags.json';
import esSettings from '../locales/es/settings.json';
import esAiAgents from '../locales/es/aiAgents.json';
import esFlowBuilder from '../locales/es/flowBuilder.json';
import esCrm from '../locales/es/crm.json';
import esKnowledge from '../locales/es/knowledge.json';
import esIntegrations from '../locales/es/integrations.json';
import esScheduled from '../locales/es/scheduled.json';
import esAdmin from '../locales/es/admin.json';
import esMediaLibrary from '../locales/es/mediaLibrary.json';

const resources = {
  'pt-BR': {
    common: ptBRCommon,
    auth: ptBRAuth,
    dashboard: ptBRDashboard,
    tickets: ptBRTickets,
    contacts: ptBRContacts,
    connections: ptBRConnections,
    queues: ptBRQueues,
    users: ptBRUsers,
    quickReplies: ptBRQuickReplies,
    tags: ptBRTags,
    settings: ptBRSettings,
    aiAgents: ptBRAiAgents,
    flowBuilder: ptBRFlowBuilder,
    crm: ptBRCrm,
    knowledge: ptBRKnowledge,
    integrations: ptBRIntegrations,
    scheduled: ptBRScheduled,
    admin: ptBRAdmin,
    chat: ptBRChat,
    mediaLibrary: ptBRMediaLibrary,
  },
  en: {
    common: enCommon,
    auth: enAuth,
    dashboard: enDashboard,
    tickets: enTickets,
    contacts: enContacts,
    connections: enConnections,
    queues: enQueues,
    users: enUsers,
    quickReplies: enQuickReplies,
    tags: enTags,
    settings: enSettings,
    aiAgents: enAiAgents,
    flowBuilder: enFlowBuilder,
    crm: enCrm,
    knowledge: enKnowledge,
    integrations: enIntegrations,
    scheduled: enScheduled,
    admin: enAdmin,
    mediaLibrary: enMediaLibrary,
  },
  es: {
    common: esCommon,
    auth: esAuth,
    dashboard: esDashboard,
    tickets: esTickets,
    contacts: esContacts,
    connections: esConnections,
    queues: esQueues,
    users: esUsers,
    quickReplies: esQuickReplies,
    tags: esTags,
    settings: esSettings,
    aiAgents: esAiAgents,
    flowBuilder: esFlowBuilder,
    crm: esCrm,
    knowledge: esKnowledge,
    integrations: esIntegrations,
    scheduled: esScheduled,
    admin: esAdmin,
    mediaLibrary: esMediaLibrary,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pt-BR',
    defaultNS: 'common',
    ns: [
      'common',
      'auth',
      'dashboard',
      'tickets',
      'contacts',
      'connections',
      'queues',
      'users',
      'quickReplies',
      'tags',
      'settings',
      'aiAgents',
      'flowBuilder',
      'crm',
      'knowledge',
      'integrations',
      'scheduled',
      'admin',
      'chat',
      'mediaLibrary',
    ],
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    // Force reload translations on key not found
    returnEmptyString: false,
    returnNull: false,
  });

export default i18n;
